var win_w 	= 0;

// Carousel
var carousel_fade_speed     = 1000;
var carousel_change         = false;
var carousel_interval       = 0;
var carousel_current_index  = 0;
var next_carousel_index     = 1;
var carousel_interval_speed = 7000;
var carousel_num_items      = 0;

jQuery(document).ready(function($) {
	win_w = $(document).width();

  init_ui();

  // Mobile navi
  $('button.hamburger').click(function() {
    $(this).find('span#nav-icon').toggleClass('open');
    $(this).toggleClass('open');
    $('body').toggleClass('navi-open');
    if ( $('body.navi-open').length > 0 ) {
      $('nav.main-navi').slideDown(300);
      $(this).attr('aria-expanded', 'true');
    }
    else {
      $('nav.main-navi').hide();
      $(this).attr('aria-expanded', 'false');
    }
  });

  /*if ( win_w < 990 ) {
    $('li.menu-item-has-children > a').click(function(e) {
      if ( !$(this).hasClass('open') ) {
        e.preventDefault();
        $(this).addClass('open');
        $(this).parent().find('ul').show();
      }
      else {
        $(this).removeClass('open');
      }
    });
  }*/

  // Carousel
  if ( $('div.carousel-items').length > 0 ) {
    set_carousel_navi();
    carousel_num_items  = $('div.carousel-items').children().length;
    if ( carousel_num_items > 1 ) {
      carousel_interval = setInterval('carousel_play()', carousel_interval_speed);
    }
    $('div.carousel-navi a').click(function(e) {
      e.preventDefault();
      if ( !carousel_change ) {
        clearInterval(carousel_interval);
        next_carousel_index = $(this).index();
        change_carousel(next_carousel_index);
      }
    });
    $('a.next-item-link').click(function(e) {
      e.preventDefault();
      if ( !carousel_change ) {
        clearInterval(carousel_interval);
        if ( carousel_current_index < carousel_num_items - 1 )
          next_carousel_index = carousel_current_index + 1;
        else
          next_carousel_index = 0;
        change_carousel(next_carousel_index);
      }
    });
    $('a.prev-item-link').click(function(e) {
      e.preventDefault();
      if ( !carousel_change ) {
        clearInterval(carousel_interval);
        if ( carousel_current_index == 0 )
          next_carousel_index = carousel_num_items - 1; 
        else
          next_carousel_index = carousel_current_index - 1;
        change_carousel(next_carousel_index);
      }
    });
  }

  // Avautuva sisältö

  $('a.accordion-title').click(function(e) {
    e.preventDefault();
    var elm = $(this).next();
    $('div.accordion-content-wrap').not(elm).slideUp();
    $('a.accordion-title').not(this).removeClass('open');
    $(this).toggleClass('open');
    elm.slideToggle();
  });

  // Galleria

  var galleryLinks = document.querySelectorAll('.gallery a');
  if (galleryLinks.length > 0) {

    var numLinks = galleryLinks.length;
    var currentLink = 0;

    // Create the modal
    var modal = document.createElement('div');
    modal.classList.add('modal');
    modal.innerHTML = `
      <img class="modal-image" />
      <div class="modal-title"></div>
      <a class="modal-download" href="" download>Lataa kuva</a>
      <div class="modal-counter"></div>
      <div class="modal-prev">&#10094;</div>
      <div class="modal-next">&#10095;</div>
    `;
    document.body.appendChild(modal);

    var modalImage = modal.querySelector('.modal-image');
    var modalTitle = modal.querySelector('.modal-title');
    var modalDownload = modal.querySelector('.modal-download');
    var modalCounter = modal.querySelector('.modal-counter');
    var modalPrev = modal.querySelector('.modal-prev');
    var modalNext = modal.querySelector('.modal-next');

    // Show the modal when a link is clicked
    galleryLinks.forEach(function(link, index) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        currentLink = index;
        showModal(currentLink);
      });
    });

    // Show the modal with the current image
    function showModal(index) {
      var href = galleryLinks[index].getAttribute('href');
      var title = galleryLinks[index].getAttribute('title');
      var counter = (index + 1) + '/' + numLinks;
      modalImage.setAttribute('src', href);
      modalTitle.textContent = title;
      modalDownload.setAttribute('href', href);
      modalCounter.textContent = counter;
      modal.style.display = 'block';
    }

    // Hide the modal when the background is clicked
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });

    // Show the previous image
    modalPrev.addEventListener('click', function() {
      currentLink--;
      if (currentLink < 0) {
        currentLink = numLinks - 1;
      }
      showModal(currentLink);
    });

    // Show the next image
    modalNext.addEventListener('click', function() {
      currentLink++;
      if (currentLink >= numLinks) {
        currentLink = 0;
      }
      showModal(currentLink);
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowLeft') {
        currentLink--;
        if (currentLink < 0) {
          currentLink = numLinks - 1;
        }
        showModal(currentLink);
      } else if (event.key === 'ArrowRight') {
        currentLink++;
        if (currentLink >= numLinks) {
          currentLink = 0;
        }
        showModal(currentLink);
      } else if (event.key === 'Escape') {
        modal.style.display = 'none';
      }
    });

    // Pop-up functionality
    var popUpSection = document.querySelector('section.pop-up');
    if (popUpSection) {
      var popUpItems = document.querySelectorAll('.pop-up-item');
      popUpItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          var popupContent = item.querySelector('.pop-up-content').cloneNode(true);
          var popupBg = document.createElement('div');
          popupBg.classList.add('popup-bg');
          document.body.appendChild(popupBg);
          document.body.appendChild(popupContent);
          var closeBtn = document.createElement('a');
          closeBtn.setAttribute('href', '#');
          closeBtn.classList.add('close');
          closeBtn.textContent = 'Sulje';
          popupContent.appendChild(closeBtn);
          popupContent.style.top = (window.scrollY + window.innerHeight * 0.1) + 'px';
          popupBg.style.display = 'block';
          popupContent.style.display = 'block';

          // Close pop-up
          popupBg.addEventListener('click', closePopup);
          closeBtn.addEventListener('click', closePopup);
        });
      });

      function closePopup(e) {
        e.preventDefault();
        var popupBg = document.querySelector('.popup-bg');
        var popupContent = document.querySelector('body > .pop-up-content');
        if (popupBg) popupBg.remove();
        if (popupContent) popupContent.remove();
      }
    }
  }

  // Galleria END

  // Gallerianauha
  document.querySelectorAll('section.kuvagalleria-nauha').forEach(section => {
    const speed = Number(section.dataset.speed) || 60; // px/s
    initTicker(section, { speed });
  });

}); // jQuery(document).ready

jQuery(window).resize(function() {
	win_w = jQuery(document).width();
  init_ui();
});

document.addEventListener("DOMContentLoaded", () => {
  // Lisää/poista sticky header
  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    document.body.classList.toggle("sticky-header", scrollTop > 424);
  });
});

function init_ui() {

}

function carousel_play() {
  change_carousel(next_carousel_index);
  if ( carousel_current_index < (carousel_num_items - 1) )
    next_carousel_index = carousel_current_index + 1;
  else
    next_carousel_index = 0;
}

function change_carousel(i) {
  carousel_change = true;
  var child_index = i + 1;
  var new_bg = jQuery('div.carousel-items > div:nth-child(' + child_index + ')').attr('style');
  var new_backgroung_color = jQuery('div.carousel-items > div:nth-child(' + child_index + ')').data('kuvansavy');
  jQuery('div.next-item').attr('style', new_bg).show();
  jQuery('div.current-item').fadeOut(carousel_fade_speed, function() {
    jQuery('div.current-item').attr('style', new_bg).show();
    carousel_change = false;
  });
  // Päivitetään teksti
  carousel_content_html = jQuery('div.carousel-items > div:nth-child(' + child_index + ')').html();
  jQuery('div.item-text').fadeOut(carousel_fade_speed, function() { 
    jQuery('div.item-text div').html(carousel_content_html);
    jQuery('div.item-text').fadeIn(carousel_fade_speed) 
  });
  // Change navi
  jQuery('div.carousel-navi a').removeClass('current');
  jQuery('div.carousel-navi a:nth-child(' + child_index + ')').addClass('current');
  // Other stuff
  carousel_current_index = i;
}

function set_carousel_navi() {
  var carousel_navi_count = jQuery('div.carousel-items').children().length;
  for ( var i = 0; i < carousel_navi_count; i++ ) {
    jQuery('div.carousel-navi').prepend('<a href="#">' + i + '</a>');
  }
  if ( carousel_navi_count > 1 ) {
    jQuery('div.carousel-navi, a.next-item-link, a.prev-item-link').show();
  }
  jQuery('div.carousel-navi a:nth-child(1)').addClass('current');
}

function initTicker(section, { speed = 60 } = {}) {
  const gallery = section.querySelector('.gallery');
  if (!gallery) return;

  // Täytetään sisältöä, jotta rullaaminen on saumatonta myös leveillä näytöillä
  const ensureFill = () => {
    const minWidth = section.clientWidth * 2; // vähän extraa varalle
    // Jos sisältö ei riitä, kloonaa lapsia kunnes riittää
    while (gallery.scrollWidth < minWidth && gallery.children.length) {
      gallery.append(...[...gallery.children].map(n => n.cloneNode(true)));
    }
  };

  ensureFill();

  let x = 0;
  let last = performance.now();
  let paused = false;
  let rafId = 0;

  const childWidth = (el) => {
    const cs = getComputedStyle(el);
    return el.offsetWidth + parseFloat(cs.marginLeft) + parseFloat(cs.marginRight);
  };

  const tick = (now) => {
    if (paused) return;
    const dt = (now - last) / 1000;
    last = now;

    x -= speed * dt;

    // Siirrä ensimmäisiä elementtejä loppuun, kun ne ovat kokonaan ulkona vasemmalta
    let first = gallery.firstElementChild;
    while (first) {
      const w = childWidth(first);
      if (-x >= w) {
        x += w;
        gallery.appendChild(first);
        first = gallery.firstElementChild;
      } else {
        break;
      }
    }

    gallery.style.transform = `translate3d(${x}px,0,0)`;
    rafId = requestAnimationFrame(tick);
  };

  const play = () => {
    if (!paused) return;
    paused = false;
    last = performance.now();
    rafId = requestAnimationFrame(tick);
  };

  const pause = () => {
    paused = true;
    cancelAnimationFrame(rafId);
  };

  // Käynnistys
  rafId = requestAnimationFrame((t) => { last = t; tick(t); });

  // Hover-pausetus (valinnainen, mutta kiva UX)
  //section.addEventListener('mouseenter', pause);
  //section.addEventListener('mouseleave', play);

  // Reflow leveysmuutoksiin
  let resizeTO;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTO);
    resizeTO = setTimeout(() => {
      pause();
      gallery.style.transform = 'translate3d(0,0,0)';
      x = 0;
      ensureFill();
      play();
    }, 150);
  });
}